import { Component, HostListener, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { SearchService } from '../../services/search.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Output() toggleSidebar = new EventEmitter<void>();
  @Input() sidebarCollapsed = false;
  
  public searchTerm: string = '';
  public searchResults: any | null = null;
  public isLoading: boolean = false;
  isSearchFocused: boolean = false;

  constructor(
    private _searchService: SearchService,
    private router: Router
  ) { }

  ngOnInit(): void {
    // Opcional: Implementar debounce para búsquedas
  }


  async onSearch() {
    
    if (!this.isSearchFocused) return;
  
  if (this.searchTerm.length < 2) {
    this.searchResults = null;
    return;
  }
    
    this.isLoading = true;
    try {
      this._searchService.getAll(this.searchTerm).subscribe({
        next: response => this.searchResults = response,
        error: _ => console.error(_)
      });
    } catch (error) {
      console.error('Error en la búsqueda:', error);
    } finally {
      this.isLoading = false;
    }
  }

  navigateToResult(type: string, id: string) {
    switch(type) {
      case 'project':
        this.router.navigate([`/dashboard/projects/view-project/${id}`]);
        break;
      case 'participant':
        this.router.navigate([`/dashboard/participants/profile-participant/${id}`]);
        break;
      case 'third-party':
        this.router.navigate([`/dashboard/third-partie/view/${id}`]);
        break;
    }
    this.searchTerm = '';
    this.searchResults = null;
  }

  onToggleSidebar() {
    this.toggleSidebar.emit();
  }

  clearSearch() {
    this.searchTerm = '';
    this.searchResults = null;
    this.isSearchFocused = false;
  }


  @HostListener('window:scroll')
  onWindowScroll() {
    this.isSearchFocused = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const target = event.target as HTMLElement;
    
    // Cerrar búsqueda si se hace clic fuera
    if (!target.closest('.search-container')) {
      this.isSearchFocused = false;
      if (!this.searchTerm) {
        this.searchResults = null;
      }
    }
  }

}